import {Injectable, inject, NgZone} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of, tap} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
import * as MarketplaceActions from './marketplace.actions';
import {LogService} from "../../services/log.service";
import ErrorModalComponent, {ErrorModalData} from "../../components/error-modal/error-modal.component";
import {ModalService} from "../../services/modal.service";
import {MarketplaceService} from "../../services/marketplace.service";

@Injectable()
export class MarketplaceEffects {
    #actions$ = inject(Actions);
    #marketplaceService = inject(MarketplaceService);
    #zone = inject(NgZone);
    #modalService = inject(ModalService);
    #logService = inject(LogService);

    fetchProducts$ = createEffect(() =>
        this.#actions$.pipe(
            ofType(MarketplaceActions.fetchProducts),
            mergeMap((action) =>
                this.#marketplaceService.getProducts().pipe(
                    mergeMap((response) => {
                        return [MarketplaceActions.fetchProductsSuccess({
                            data: response,
                        })];
                    }),
                    catchError((error) => {
                        this.#logService.error(error);
                        return of(MarketplaceActions.fetchProductsFailure({error}));
                    })
                )
            )
        )
    );

    createInternalHealthDataValueFailure$ = createEffect(() => this.#actions$.pipe(
        ofType(MarketplaceActions.fetchProductsFailure),
        tap(payload => {
            this.#zone.run(() => {
                this.#modalService.open<ErrorModalData, ErrorModalComponent>(ErrorModalComponent, {
                    data: {
                        error: payload.error,
                        message: 'Non è stato possibile recuperare i prodotti dal marketplace. Riprova più tardi.',
                    }
                });
            });
        })
    ), {dispatch: false});
}
